module.exports = __webpack_public_path__ + "img/slide1.5f6df9ad.png";